/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ServiceType } from 'shared';

import { PlanCompute } from '../../types/common/PlanCompute';
import { PlanStorage } from '../../types/common/PlanStorage';

export enum PlanActions {
  GET_PLAN_WATCHER = 'GET_PLAN_WATCHER',
  GET_PLAN_REQUEST = 'GET_PLAN_REQUEST',
  GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS',
  GET_PLAN_FAILURE = 'GET_PLAN_FAILURE',
}

export type PlanState = {
  isFetching: boolean;
  errorMessage?: string;
  planCompute?: PlanCompute[];
  planStorage?: PlanStorage[];
};

export type GetPlanWatcherAction = {
  type: PlanActions.GET_PLAN_WATCHER;
  payload: { serviceType: ServiceType };
};

export type GetPlanRequestAction = {
  type: PlanActions.GET_PLAN_REQUEST;
};
type GetPlanSuccessAction = {
  type: PlanActions.GET_PLAN_SUCCESS;
  payload: {
    compute: PlanCompute[];
    storage: PlanStorage[];
  };
};
type GetPlanErrorAction = {
  type: PlanActions.GET_PLAN_FAILURE;
  payload: { errorMessage?: string };
};

export type PlanActionTypes = GetPlanWatcherAction | GetPlanRequestAction | GetPlanSuccessAction | GetPlanErrorAction;
